import { CommentItem, RemixCommentResponse } from 'types/comment';

export function commentsHandler(data: any[]): CommentItem[] {
  return data.map((item: any) => {
    if (item.type === undefined && item.item === undefined) {
      return { type: 'COMMENT', item } as CommentItem;
    }

    if (item.type === 'REMIX') {
      return {
        ...item,
        item: RemixCommentResponse.fromData(item.item).toRemixComment(),
      };
    }

    return item as CommentItem;
  });
}
